/* eslint-disable react/jsx-curly-brace-presence */
import React from 'react';

export const VolLocStatusModal = {
  title: 'Volcano Status',
  body: (
    <div>
      <p>
        The Status category conveys the following hierarchical progression from high to low certainty of Holocene volcanism (from the
        {' '}
        <a href="https://volcano.si.edu/" target="_blank" rel="noopener noreferrer">Smithsonian Institution, Global Volcanism Program</a>
        )
      </p>
      <ol>
        <li>{'"Historical" - documented during or shortly after observation'}</li>
        <li>{'"Dated eruptions based on a spectrum of techniques from "Hydrophonic" through "Radiocarbon" to "Anthropology", which is transitional to "Holocene"'}</li>
        <li>{'"Thermal features such as "Fumarolic"'}</li>
        <li>{'Uncertain"'}</li>
        <li>{'"Thermal features preceded by the word "Pleistocene-"'}</li>
      </ol>
    </div>
  ),
};
